import OrgDashboard from './OrgDashboard';

export default OrgDashboard;
